<div *ngIf="!showModal" class="modal-container">
  <h1 mat-dialog-title class="modal-title">Selecciona el Proveedor</h1>
  <div class="modal-info">
    <h5>Servicio: <span [class.invalid-field]="nombreServicioInvalid">{{ nombreServicio || '—' }}</span></h5>
    <h5>Categoría: <span>{{ categoriaServicio !== "null" ? categoriaServicio : "-" }}</span></h5>
    <h5>Locación: <span>{{ categoriaServicio !== "null" ? locacion : "-" }}</span></h5>
  </div>

  <div mat-dialog-content class="modal-content">
    <p *ngIf="!isLoading && providersMessage" class="providers-status-message">
      {{ providersMessage }}
    </p>

    <mat-form-field
      appearance="fill"
      *ngIf="!isLoading && !providersEmpty"
      class="search-field"
    >
      <mat-label class="search-text">Proveedores</mat-label>

      <input type="text" matInput [formControl]="myControl" [matAutocomplete]="auto" />

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="getOptionText">
        <mat-option
          style="font-size: 11px; height: 3em"
          *ngFor="let option of filteredOptions | async"
          [value]="option"
        >
          {{ option.nombre }}
        </mat-option>
        <mat-option style="font-size: 11px" *ngIf="providerList.length == 0">
          {{ providersMessage || 'No hay proveedores disponibles' }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <div *ngIf="!isLoading && providersEmpty" class="providers-empty-state">
      <mat-icon>info_outline</mat-icon>
      <p>{{ providersMessage }}</p>
    </div>

    <div *ngIf="isLoading" class="loading-spinner">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <div mat-dialog-actions class="modal-actions">
    <button mat-button (click)="onNoClick()" class="button-secondary">Cancelar</button>
    <button
      mat-button
      class="button-primary"
      (click)="saveChangeProvider()"
      [disabled]="providersEmpty || !providerList.length"
      cdkFocusInitial
    >
      Guardar
    </button>
  </div>
</div>

<div *ngIf="showModal" class="modal-result">
  <div class="result-icon">
    <mat-icon *ngIf="iconResult" class="icon-check">check_circle</mat-icon>
    <mat-icon *ngIf="!iconResult" class="icon-error">error_outline</mat-icon>
  </div>

  <div class="result-message">
    <p class="message-result">
      <i>{{ messageResult }}</i>
    </p>
  </div>
</div>
